import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { SelectValue } from 'antd/lib/select';
import { FilterDateOperator, Undefinable } from 'providence-types';
import { arraySort, getCurrentOptions } from '@core/utils/methods';
import { FiltersSetDataFilter } from '@models/interfaces';
import { FormInstanceExtender } from '@models/types';
import { DatePicker, RangePicker } from '@shared/modules';
import { ItemWithOperator } from '../item-with-operator';
import { ComponentWithOperatorProps, getFilterOperator } from '../models';

type DateWithOperatorProps = ComponentWithOperatorProps &
  FiltersSetDataFilter &
  FormInstanceExtender;

export const DateWithOperator: FC<DateWithOperatorProps> = ({
  value,
  form,
  ...props
}: PropsWithChildren<DateWithOperatorProps>) => {
  const operator = form?.getFieldsValue()[props.id]?.operator ?? value.operator;

  const [operatorValue, setOperatorValue] = useState<Undefinable<SelectValue>>(
    value.operator,
  );

  const onChange = (v: SelectValue): void => {
    if (
      (operatorValue !== FilterDateOperator.Between &&
        v === FilterDateOperator.Between) ||
      (operatorValue === FilterDateOperator.Between &&
        v !== FilterDateOperator.Between)
    ) {
      form?.resetFields([[props.id, 'value']]);
    }

    setOperatorValue(v);
  };

  useEffect(() => {
    setOperatorValue(value.operator);
  }, [value]);

  return (
    <ItemWithOperator
      component={
        operator !== FilterDateOperator.Between ? DatePicker : RangePicker
      }
      className="prov-date-with-operator"
      selectProps={{
        options: arraySort(
          getCurrentOptions(FilterDateOperator, getFilterOperator, false, true),
          'ASC',
          'viewValue',
        ),
        label: '',
        elementProps: {
          onChange,
        },
      }}
      {...props}
    />
  );
};
